// candidateLocation returns THE display string for where a candidate is based —
// one precedence rule shared by every surface that renders a contact's location
// (list rows, search results, hover card, profile header):
//   1. geoLocation.displayName — the canonical geocoded name (clean, localized,
//      e.g. "Berlin, Deutschland"), present once the candidate has been geocoded.
//   2. locationDisplay — the LLM-localized "City, Country" form from enrichment,
//      for candidates enriched before geocoding existed (or non-geocodable input).
//   3. location — the raw imported/typed free text, the source of truth.
// Returns "" (never undefined) so callers can use the result both as render text
// and as a truthiness guard without extra null checks.
export function candidateLocation(c) {
  if (!c) return "";
  return c.geoLocation?.displayName || c.locationDisplay || c.location || "";
}
